module.exports = __webpack_public_path__ + "static/media/i2sysbio_logo.f3e049da.png";